import React, { FC } from "react";
import styles from "./styles.module.scss";
import { VariantColors } from "@/types/ds";

interface ButtonProps {
  children: React.ReactNode;
  id?: string;
  outlined?: boolean;
  text?: boolean;
  disabled?: boolean;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: VariantColors;
  icon?: boolean;
  iconRounded?: boolean;
  shoppingCart?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  className?: string;
  customStyle?: React.CSSProperties;
}

export const Button: FC<ButtonProps> = ({
  children,
  outlined = false,
  text = false,
  disabled = false,
  size,
  variant,
  icon = false,
  iconRounded = false,
  shoppingCart = false,
  fullWidth = true,
  onClick = () => {},
  customStyle = {},
  ...rest
}) => {
  const hasSize = size ? ` btn-${size}` : "";
  const isText = text ? " btn-text" : "";
  const isOutlined = outlined ? " outlined" : "";
  const isDisabled = disabled ? " disabled" : "";
  const isIcon = icon ? " btn-icon" : "";
  const isIconRounded = iconRounded ? " btn-icon-rounded" : "";
  const hasVariant = variant && ` btn-${variant}`;
  const isShoppingCart = shoppingCart ? " shopping-cart" : "";
  const isFullWidth = fullWidth ? " fullwidth" : "";

  const classes =
    hasSize +
    isText +
    isOutlined +
    isDisabled +
    isIcon +
    isIconRounded +
    hasVariant +
    isShoppingCart +
    isFullWidth;

  return (
    <button
      onClick={onClick}
      className={`${styles.wrapper} btn${classes}`}
      style={{
        ...(fullWidth ? { width: "100%", justifyContent: "center" } : {}),
        ...customStyle
      }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
